/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { PublishingSummaryDtoModel, PublishingSummaryDtoModelType } from "./PublishingSummaryDtoModel"
import { PublishingSummaryDtoModelSelector } from "./PublishingSummaryDtoModel.base"
import { RootStoreType } from "./index"


/**
 * PlanningNotificationsResponseBase
 * auto generated base class for the model PlanningNotificationsResponseModel.
 */
export const PlanningNotificationsResponseModelBase = ModelBase
  .named('PlanningNotificationsResponse')
  .props({
    __typename: types.optional(types.literal("PlanningNotificationsResponse"), "PlanningNotificationsResponse"),
    publishingSummary: types.union(types.undefined, types.null, types.late((): any => PublishingSummaryDtoModel)),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class PlanningNotificationsResponseModelSelector extends QueryBuilder {
  publishingSummary(builder: string | PublishingSummaryDtoModelSelector | ((selector: PublishingSummaryDtoModelSelector) => PublishingSummaryDtoModelSelector) | undefined) { return this.__child(`publishingSummary`, PublishingSummaryDtoModelSelector, builder) }
}
export function selectFromPlanningNotificationsResponse() {
  return new PlanningNotificationsResponseModelSelector()
}

export const planningNotificationsResponseModelPrimitives = selectFromPlanningNotificationsResponse()
